import { useEffect } from "react";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { useMeQuery } from "../../../hooks/me/useMe";
import Layout from "../../templates/Layout";
import { getAppUserRoleLabel } from "../../../types/roles";
import { formatDateTimeJST } from "../../../utils/date";
import DetailLayout from "../../Layout/DetailLayout";
import { handleError } from "../../../utils/error/handleError";
import { useMenu } from "../../../hooks/useMenu";
import { useAppNavigate } from "../../../routes/useAppNavigate";
import ManagedChips from "../../Chip/ManagedChips";
import { isWorker } from "../../../utils/role/isRole";

const DetailAccountPage = () => {
  const { meNavigate } = useAppNavigate();
  const { data, isFetching, error, isError } = useMeQuery();
  const menu = useMenu();

  useEffect(() => {
    if (isError) {
      handleError(error);
    }
  }, [error, isError]);

  return (
    <Layout title="アカウント設定">
      <DetailLayout
        toolbar={
          <>
            <Typography>アカウント設定</Typography>
            <IconButton onClick={menu.onOpen} disabled={isFetching}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
              anchorEl={menu.anchorEl}
              open={menu.open}
              onClose={menu.onClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  meNavigate.update();
                }}
              >
                アカウント設定編集
              </MenuItem>
              {data && !isWorker(data.role) && (
                <MenuItem
                  onClick={() => {
                    meNavigate.setCurrentBuilding();
                  }}
                >
                  利用ビル変更
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  meNavigate.setPassword();
                }}
              >
                パスワード変更
              </MenuItem>
            </Menu>
          </>
        }
        items={[
          {
            label: "ユーザー名",
            value: data?.userName,
            isLoading: isFetching,
          },
          {
            label: "ログインID",
            value: data?.loginId,
            isLoading: isFetching,
          },
          {
            label: "メールアドレス",
            value: data?.email,
            isLoading: isFetching,
          },
          {
            label: "権限",
            value: data && getAppUserRoleLabel(data?.role),
            isLoading: isFetching,
          },
          {
            label: "所属テナント",
            value: data?.tenant?.tenantName ?? "",
            isLoading: isFetching,
          },
          {
            label: "管理範囲",
            value: !!data && <ManagedChips user={data} />,
            isLoading: isFetching,
          },
          {
            label: "利用ビル",
            value: data?.currentBuilding?.buildingName ?? "",
            isLoading: isFetching,
          },
          {
            label: "作成日時",
            value: data && formatDateTimeJST(data?.createdAt),
            isLoading: isFetching,
          },
          {
            label: "更新日時",
            value: data && formatDateTimeJST(data?.updatedAt),
            isLoading: isFetching,
            withDivider: false,
          },
        ]}
      />
    </Layout>
  );
};

export default DetailAccountPage;
